import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export const DeedFeesCard = () => {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/deed-fees").then((r) => setF(r.data)); }, []);
  if (!f) return null;
  const save = async () => {
    try { setF((await api.put("/admin/deed-fees", { doner_sermaye: Number(f.doner_sermaye), harc_per_mille: Number(f.harc_per_mille) })).data); toast.success("Tapu masrafları güncellendi"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <Card className="p-5 space-y-3" data-testid="deed-fees-card">
      <div>
        <div className="font-semibold text-slate-900">Tapu masrafları</div>
        <p className="text-sm text-slate-500">Tüm ofislerin tapu takip kayıtlarında otomatik kullanılır.</p>
      </div>
      <div className="grid md:grid-cols-[1fr_1fr_auto] gap-3 items-end">
        <div><Label>Döner sermaye (TL, TC vatandaşı)</Label><Input data-testid="doner-input" type="number" min="0" value={f.doner_sermaye} onChange={(e) => setF({ ...f, doner_sermaye: e.target.value })} /></div>
        <div><Label>Tapu harcı oranı (binde)</Label><Input data-testid="harc-input" type="number" min="0" step="0.1" value={f.harc_per_mille} onChange={(e) => setF({ ...f, harc_per_mille: e.target.value })} /></div>
        <Button data-testid="deed-fees-save" onClick={save}>Kaydet</Button>
      </div>
    </Card>
  );
};
